class EmployerGuideLogin {

    constructor(loginForm) {
        this.login = this.login.bind(this);

        this.loginBtn = document.querySelector('#employer-guide-login-button');
        if (this.loginBtn) {
            this.loginBtn.addEventListener('click', this.login);
        }

        this.loginForm = loginForm;
        this.defaultLoginBtnText = 'Logga in';
        this.message = document.querySelector('.employer-guide-login-search__login-message');
        this.defaultMessage = document.querySelector('.employer-guide-login-search__login-message').textContent;
    }

    login(e) {
        e.preventDefault();

        this.message.style.display = 'none';
        if (!document.querySelector('.employer-guide-login-search__login-form').reportValidity()) {
            return;
        }

        this.loginForm.classList.add('loading');

        const loadingDots = document.createElement("div");
        loadingDots.classList.add("employer-guide-login-search__loading-dots", "loading-dots");
        for (let i = 0; i < 4; i++) {
            const child = document.createElement("div");
            loadingDots.appendChild(child);
        }
        this.loginForm.after(loadingDots);

        fetch(this.loginForm.getAttribute('action'), {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
                username: this.loginForm.querySelector('#employer-login-username').value,
                password: this.loginForm.querySelector('#employer-login-password').value
            })
        }).then((response) => {
            if (response.status >= 200 && response.status < 300) {
                return response;
            } else {
                var error = new Error(response.statusText);
                error.response = response;
                throw error;
            }
        }).then((response) => {
            return response.json();
        }).then((json) => {
            if (json.status === 200) {
                window.location = json.redirectUrl;

                dataLayer.push({
                    'event': 'login',
                    'logedinStatus': 'Login',
                    'selectedBranch': json.branch
                });
            } else {
                this.message.style.display = 'block';
                this.loginForm.classList.remove('loading');
                document.querySelector('.employer-guide-login-search__loading-dots').remove();
            }

        }).catch((ex) => {
            console.log(ex);
        });
    }

    reset() {
        this.message.innerHTML = `<p>${this.defaultMessage}</p>`;
        this.message.style.color = '#FF4040';
        this.message.style.display = 'none';
        document.querySelector('#employer-login-password').removeAttribute('disabled');
        this.loginBtn.addEventListener('click', this.login);
    }
}



function addSearchEvent() {
    const form = document.querySelector('.employer-guide-login-search__search-form');
    const searchHeading = document.querySelector("input[type='search']");
    if (!form || !searchHeading) return;

    form.addEventListener('submit', () => {
        const searchTerm = searchHeading.value;
        dataLayer.push({
            'event': 'searchArbetsgivarguiden',
            'Search_term': searchTerm,
        });

    })
}

document.addEventListener("DOMContentLoaded", () => {
    if (!window.authenticated) {
        const loginForm = document.querySelector('.employer-guide-login-search__login-form');
        if (loginForm) {
            new EmployerGuideLogin(loginForm);
        }
    }

    if (document.querySelector('.employer-guide-login-search--authorized')) {
        addSearchEvent();
    }
});
